import {Pipe, PipeTransform} from "@angular/core";
import { IManagableObject } from "../../admin-panel/IManagableObject";

@Pipe({
    name: 'filterByName',
    pure: false,
    standalone: false
})
export class FilterByNamePipe implements PipeTransform
{
  transform(items: IManagableObject[], term: string): any
  {
    if (!items) return [];
    if (!term || term == "") return items;

    let lowerCaseTerm = term.toLowerCase();
    var res = [];
    for (let i = 0; i < items.length; i++)
      if (items[i].Name.toLowerCase().indexOf(lowerCaseTerm) >= 0)
        res.push(items[i]);
      //else
        //items[i].IsChecked = false;
    return res;
  }
}
